// Vuex is a state management pattern + library for Vue.js applications.
import Vue from "vue";
import Vuex from "vuex";

// import modules
import main from "./modules/main";
import projects from "./modules/projects";
import filters from "./modules/filters";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        main,
        projects,
        filters,
    },
});
